import {ReactNode, useEffect, useState} from 'react';

import Redirect from '../Redirect.client';
import {useAuthService} from '../../contexts/AuthServiceProvider.client';

interface RedirectNonRewardsMemberProps {
  children: ReactNode;
  redirectChildren?: ReactNode;
  next?: string;
}

export default function RedirectNonRewardsMember({
  children,
  next,
  redirectChildren,
}: RedirectNonRewardsMemberProps) {
  const [disableRedirect, setDisableRedirect] = useState(false);
  const {authUser} = useAuthService();

  useEffect(() => {
    // we don't want to redirect if redirection has been disabled at any point
    setDisableRedirect(
      (current) => current || Boolean(authUser?.member?.is_rewards_member),
    );
  }, [authUser?.member?.is_rewards_member]);

  if (!authUser?.member?.is_rewards_member && !disableRedirect) {
    return (
      <Redirect to={next ? next : `/l/rewards`} replace={true}>
        {redirectChildren ?? <div className="mt-10">Redirecting...</div>}
      </Redirect>
    );
  }

  return <>{children}</>;
}
